import { render, staticRenderFns } from "./optionSet.vue?vue&type=template&id=8206d064&scoped=true"
import script from "./optionSet.vue?vue&type=script&lang=js"
export * from "./optionSet.vue?vue&type=script&lang=js"
import style0 from "./optionSet.vue?vue&type=style&index=0&id=8206d064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8206d064",
  null
  
)

export default component.exports